const prefix = 'qbrole/'

const type = {
    LOAD_LIST_ROLE: prefix + 'load_list_role',
    LOAD_LIST_ROLE_SUCCESS: prefix + 'load_list_role_success',
    SET_DEFAULT_CURRENT_ROLE: prefix + 'set_default_current_role',
    UPDATE_CURRENT_ROLE: prefix + 'update_current_role',
    SAVE_CURRENT_ROLE: prefix + 'save_current_role',
    DELETE_ROLE: prefix + 'delete_role',
    UPDATE_STATE: prefix + 'update_state',

    CHANGE_PAGE_SIZE: prefix + 'change_page_size',
    CHANGE_CURRENT_PAGE: prefix + 'change_current_page',

    SHOW_MODAL_CURRENT_ROLE_INFO: prefix + 'show_modal_current_role_info',
    DISMISS_MODAL_CURRENT_ROLE_INFO: prefix + 'dismiss_modal_current_role_info',
    SHOW_MODAL_CONFIRM_DELETE_ROLE: prefix + 'show_modal_confirm_delete_role',
    DISMISS_MODAL_CONFIRM_DELETE_ROLE:
        prefix + 'dismiss_modal_confirm_delete_role',

    UPDATE_ACTION: prefix + 'update_action',
    UPDATE_ALL_ACTION: prefix + 'update_all_action',

    GET_CURRENT_ROLE_USER: prefix + 'get_current_row',
    GET_CURRENT_ROLE_USER_DONE: prefix + 'get_current_row_done',
}

const action = {
    getCurrentRoleOfUser: rid => {
        return {
            type: type.GET_CURRENT_ROLE_USER,
            payload: {
                rid,
            },
        }
    },
    getCurrentRoleOfUserDone: data => {
        return {
            type: type.GET_CURRENT_ROLE_USER_DONE,
            payload: {
                data,
            },
        }
    },

    loadListRoles: params => {
        return {
            type: type.LOAD_LIST_ROLE,
            payload: {
                params,
            },
        }
    },
    loadListRolesSuccess: roles => {
        return {
            type: type.LOAD_LIST_ROLE_SUCCESS,
            payload: {
                roles,
            },
        }
    },
    setDefaultCurrentRole: () => {
        return {
            type: type.SET_DEFAULT_CURRENT_ROLE,
            payload: {},
        }
    },
    updateCurrentRole: role => {
        return {
            type: type.UPDATE_CURRENT_ROLE,
            payload: {
                role,
            },
        }
    },
    saveCurrentRole: () => {
        return {
            type: type.SAVE_CURRENT_ROLE,
            payload: {},
        }
    },
    deleteRole: roleId => {
        return {
            type: type.DELETE_ROLE,
            payload: {
                roleId,
            },
        }
    },
    updateState: state => {
        return {
            type: type.UPDATE_STATE,
            payload: {
                state,
            },
        }
    },
    changePageSize: pageSize => {
        return {
            type: type.CHANGE_PAGE_SIZE,
            payload: {
                pageSize,
            },
        }
    },
    changeCurrentPage: pageIndex => {
        return {
            type: type.CHANGE_CURRENT_PAGE,
            payload: {
                pageIndex,
            },
        }
    },
    showModalCurrentRoleInfo: () => {
        return {
            type: type.SHOW_MODAL_CURRENT_ROLE_INFO,
            payload: {},
        }
    },
    dismissModalCurrentRoleInfo: () => {
        return {
            type: type.DISMISS_MODAL_CURRENT_ROLE_INFO,
            payload: {},
        }
    },
    showModalConfirmDeleteRole: () => {
        return {
            type: type.SHOW_MODAL_CONFIRM_DELETE_ROLE,
            payload: {},
        }
    },
    dismissModalConfirmDeleteRole: () => {
        return {
            type: type.DISMISS_MODAL_CONFIRM_DELETE_ROLE,
            payload: {},
        }
    },
    updateAction: (actionId, status) => {
        return {
            type: type.UPDATE_ACTION,
            payload: {
                actionId,
                status,
            },
        }
    },
    updateAllAction: status => {
        return {
            type: type.UPDATE_ALL_ACTION,
            payload: {
                status,
            },
        }
    },
}

export default {
    type,
    action,
}
